export default __webpack_public_path__ + "static/media/viewPeople.faaad8ce.png";